import script from "./Pages.vue?vue&type=script&setup=true&lang=js"
export * from "./Pages.vue?vue&type=script&setup=true&lang=js"

import "./Pages.vue?vue&type=style&index=0&id=634baddd&lang=scss"

const __exports__ = script;

export default __exports__